import React, { useEffect, useState } from "react"
import ABPkwPage from "./abpkw"
import OldPkw from "./pkwOld"

export default function Page() {
  const [redesignPage, setRedesignPage] = useState(false)

  useEffect(() => {
    if ((globalThis as any).KameleoonExperiment_349635 === 1209235) {
      setRedesignPage(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(globalThis as any).KameleoonExperiment_349635])

  return redesignPage ? <ABPkwPage /> : <OldPkw />
}
